import React, { useEffect, useState } from 'react';
import { returnAPI } from './SellerApi';

export const SellerReturns = () => {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    returnAPI.list()
      .then(r => setReturns(r.data || []))
      .catch(() => setReturns([
        { id: 'RET-01', order_id: 'ATR-9900', product_name: 'Noise-Cancelling Headphones', customer_name: 'Anbu S.', reason: 'Wrong color version delivered', status: 'pending', created_at: '2026-05-10', refund_amount: 3200 },
      ]))
      .finally(() => setLoading(false));
  }, []);

  const handleAction = async (id, action) => {
    try {
      await returnAPI.action(id, action);
      setReturns(r => r.map(x => x.id === id ? { ...x, status: action === 'approve' ? 'approved' : 'rejected' } : x));
    } catch (err) {
      alert(err.message || "Failed to process return request");
    }
  };

  return (
    <div className="sp-card">
      <div className="sp-card-title">Return & Refund Claims</div>
      {loading ? <div className="sp-skeleton" style={{ height: 180 }} /> : (
        <div className="sp-table-wrap">
          <table className="sp-table">
            <thead>
              <tr><th>Claim ID</th><th>Order</th><th>Product</th><th>Customer</th><th>Reason</th><th>Refund Liability</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {returns.map(r => (
                <tr key={r.id}>
                  <td className="td-hi">#{r.id}</td>
                  <td>#{r.order_id}</td>
                  <td>{r.product_name}</td>
                  <td>{r.customer_name}</td>
                  <td style={{ maxWidth: 180, fontSize: 12, color: 'var(--t2)' }}>{r.reason}</td>
                  <td className="td-gold">₹{r.refund_amount}</td>
                  <td><span className={`sp-badge ${r.status === 'approved' ? 'delivered' : r.status === 'rejected' ? 'cancelled' : 'pending'}`}>{r.status}</span></td>
                  <td>
                    {r.status === 'pending' && (
                      <div style={{ display: 'flex', gap: '0.4rem' }}>
                        <button className="sp-btn-primary" style={{ padding: '4px 10px', fontSize: 11 }} onClick={() => handleAction(r.id, 'approve')}>Approve</button>
                        <button className="sp-btn-danger" style={{ padding: '4px 10px', fontSize: 11 }} onClick={() => handleAction(r.id, 'reject')}>Reject</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {returns.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: 'center', color: 'var(--t3)', padding: '2rem' }}>No return claims found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};